import { MakeCall } from './createMakeCall';

const publishListing = (makeCall: MakeCall) => (listingId: number) =>
  makeCall<undefined>('PUT', `/api/v2/listing/${listingId}/publish`);
export { publishListing };
